import { CheckCircle2, ChevronDown, CircleDashed, Sparkles } from 'lucide-react';
import type { Requirements } from '../types';

const budgetLabels: Record<string, string> = { economical: 'اقتصادی', midrange: 'میان‌رده', luxury: 'لوکس' };

const faCount = (value: number) => value.toLocaleString('fa-IR');

export function RequirementPanel({ requirements }: { requirements?: Requirements | null }) {
  const chips = [
    { label: 'فضا', value: requirements?.roomType },
    { label: 'سبک', value: requirements?.style },
    { label: 'حس‌وحال', value: requirements?.atmosphere },
    { label: 'بودجه', value: requirements?.budgetTier ? budgetLabels[requirements.budgetTier] || requirements.budgetTier : null },
    { label: 'کاربرد', value: requirements?.useCase },
    { label: 'محصول', value: requirements?.preferredCategories?.length ? requirements.preferredCategories.join('، ') : null },
  ];
  const filled = chips.filter((chip) => chip.value).length;
  const complete = filled === chips.length;
  return <details className="requirement-panel" aria-label="برداشت مشاور از نیازهای شما">
    <summary>
      <span className="requirement-title"><strong>خلاصه نیازهای طراحی</strong><small>{complete ? 'آماده ساخت تصویر' : `${faCount(filled)} مورد از ${faCount(chips.length)} مشخص شده`}</small></span>
      <span className="requirement-count">{faCount(filled)}/{faCount(chips.length)}</span>
      <ChevronDown className="requirement-chevron" size={18} />
    </summary>
    <div className="requirement-content">
      <div className="requirement-chips">
        {chips.map((chip) => <div key={chip.label} className={`requirement-chip ${chip.value ? 'filled' : ''}`}>
          <span className="chip-head"><span className="chip-state">{chip.value ? <CheckCircle2 size={14} /> : <CircleDashed size={14} />}</span><span className="chip-label">{chip.label}</span></span>
          <span className="chip-value" title={chip.value ?? undefined}>{chip.value || 'هنوز نامشخص'}</span>
        </div>)}
      </div>
      <div className="requirement-progress" role="progressbar" aria-label="تکمیل اطلاعات طراحی" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={chips.length}>
        <i style={{ width: `${(filled / chips.length) * 100}%` }} />
      </div>
      <p className={`requirement-footnote ${complete ? 'complete' : ''}`}>
        {complete
          ? <><Sparkles size={14} /> اطلاعات لازم کامل است؛ بعد از بررسی محصولات می‌توانید تصویر را بسازید.</>
          : 'با هر پاسخ، این خلاصه به‌روز می‌شود.'}
      </p>
    </div>
  </details>;
}
